<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <div>
      <b-card>
        <b-row>
          <b-col>
            <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("senderfio") }}:</h6>
              </b-col>
              <b-col>
                <h6>{{ Offer.senderfio }}</h6>
              </b-col>
            </b-row>
        
            <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("senderphone") }}:</h6>
              </b-col>
              <b-col>
                <h6>{{ Offer.senderphone }}</h6>
              </b-col>
            </b-row>
         
            <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("senderemail") }}:</h6>
              </b-col>
              <b-col>
                <h6>{{ Offer.senderemail }}</h6>
              </b-col>
            </b-row>
             <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("oblast") }}:</h6>
              </b-col>
              <b-col>
                <h6 >{{ Offer.oblastname }}</h6>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("text") }}:</h6>
              </b-col>
              <b-col>
                <h6>{{ Offer.text }}</h6>
              </b-col>
            </b-row>
             <b-row>
              <b-col sm="12" lg="2">
                <h6>{{ $t("viewcount") }}:</h6>
              </b-col>
              <b-col>
                <h6>{{ Offer.viewcount }}</h6>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
      <b-card :title="$t('Comment')">
          <b-row>
              <b-col v-for="(item,index) in Offer.Tables" :key="index" >
                 <b-row>
                     <b-col sm="12" lg="2">{{$t('date')}}</b-col>
                      <b-col>{{$t('text')}}</b-col>
                 </b-row>
                 <b-row>
                     <b-col sm="12" lg="2">
                         {{item.date}}
                     </b-col>
                     <b-col>
                         {{item.text}}
                     </b-col>
                 </b-row>
              </b-col>
          </b-row>
      </b-card>
      <b-row>
        <b-col>
          <b-card>
            <b-row>
              <b-col class="text-right">
                <b-button
                  @click="$router.push('/info/Offer')"
                  class="d-inline-block "
                  variant="danger"
                  ><i class="dripicons-arrow-thin-left"></i>
                  {{ $t("back") }}</b-button
                >
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </Layout>
</template>
<script>
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import Layout from "../../../router/layouts/main.vue";
import PageHeader from "@/components/page-header";
import OfferService from "@/services/info/Offer.service";
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Multiselect,
    Layout,
    PageHeader,
    DatePicker,
    vSelect,
  },
  data() {
    return {
      title: this.$t("Offer"),
      braedcrumb: [
        {
          text: this.$t("Offer"),
        },
        {
          text: this.$t("CalculationKind"),
          active: true,
        },
      ],
      items: [],
      Offer: {},
      isLoading: false,

      LanguageList: [],
      editedIndex1: -1,
      lang: "ru",
      files: [],
      file: [],
      url1: [],
      LoadImage: [],
    };
  },
  created() {
    this.lang = localStorage.getItem("locale") || "ru";
    this.show = true;
    OfferService.Get(this.$route.params.id)
      .then((res) => {
        this.show = false;
        this.Offer = res.data;
      })
      .catch((error) => {
        this.$notification(error.response.data.error, "danger");
      });
  },
  directives: {},
  methods: {},
};
</script>

<style></style>
